export default [
  {
    name: "Josiah Enyart",
    title: "President/CEO",
    photo: "/profiles/josiah.jpg",
    infoItems: ["Husband & Father of 3", "Educational Entrepreneur", "Speaker"],
  },
  {
    name: "Chris Fees",
    title: "Vice President",
    photo: null,
    infoItems: [
      "Husband and Homeschool father of 8",
      "HSLDA Sales Force Representative",
    ],
  },
  {
    name: "Michelle Fees",
    title: "Secretary",
    photo: null,
    infoItems: [
      "Homeschool mother of 8",
      "15+ years of nonprofit accounting experience",
    ],
  },
  {
    name: "Lynn McLarty",
    title: "Treasurer",
    photo: null,
    infoItems: [
      "Husband, Father of 5, Grandfather of 11",
      "Retired Navy and Data Services Technician",
    ],
  },
  {
    name: "Travis Olsen",
    title: "Board Member",
    photo: null,
    infoItems: [
      "Husband and father of 3",
      "Retired Navy and Data Services Technician",
      "Educator and University Model Parent",
    ],
  },
  {
    name: "Becka Eisman",
    title: "Board Member",
    photo: null,
    infoItems: ["40 years as Human Resource Manager/Director"],
  },
];
